import { MenuOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Radio, RadioChangeEvent } from 'antd';
import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

type Props = {
    menu: string,
    type: string
}

const items = [
    // {
    //     key: 'bet',
    //     label: 'แทงหวย',
    //     route: 'bet'
    // },
    {
        key: 'rules',
        label: 'กติกาการเล่น',
        route: 'rules'
    },
    {
        key: 'member',
        label: 'จัดการสมาชิก',
        route: 'member'
    },
    {
        key: 'admin',
        label: 'จัดการแอดมิน',
        route: 'admin'
    },
    {
        key: 'result',
        label: 'สรุปยอด',
        route: 'result'
    },
    {
        key: 'announce',
        label: 'ออกผล',
        route: 'announce'
    },
    // {
    //     key: 'document',
    //     label: 'คู่มือการใช้งาน',
    //     route: 'document'
    // },
    {
        key: 'setting',
        label: 'ตั้งค่า',
        route: 'setting'
    },
];

const MenuNav: FC<Props> = ({ menu, type }) => {
    let history = useHistory();
    const role = localStorage.getItem("role");

    const goRoute = (type: string, e: RadioChangeEvent | any) => {
        let menuName = '/';
        if (type === 'radio') {
            menuName = '/' + e.target.value;
            if (menuName === '/bet') menuName = '/';
        } else {
            menuName = '/' + e.key;
            if (menuName === '/bet') menuName = '/';
        }

        // console.log(history.location);
        
        // window.location.href = menuName;
        history.push(menuName);
        // history
    }

    if (type === 'radio') {
        return (
            <Radio.Group defaultValue={menu} buttonStyle="solid" style={{ marginLeft: 20, borderRadius: 8 }} onChange={(e) => goRoute('radio', e)}>
                {/* <Radio.Button value="bet">แทงหวย</Radio.Button> */}
                <Radio.Button value="bet-report">รายการแทง</Radio.Button>
                <Radio.Button value="rules">กติกาการเล่น</Radio.Button>
                <Radio.Button value="member">จัดการสมาชิก</Radio.Button>
                {role === 'super-admin' ? <Radio.Button value="admin">จัดการแอดมิน</Radio.Button> : <></> }
                <Radio.Button value="result">บัญชีการเงิน</Radio.Button>
                <Radio.Button value="announce">ออกผล</Radio.Button>
                {/* <Radio.Button value="document">คู่มือการใช้งาน</Radio.Button> */}
                <Radio.Button value="setting">ตั้งค่า</Radio.Button>
                
            </Radio.Group>
        )
    }

    return (<Dropdown overlay={<Menu items={items} onClick={(e) => goRoute('dropdown', e)} />} placement="bottomLeft">
        <Button style={{ float: 'right', marginRight: 10, marginTop: 15 }}>
            <MenuOutlined />
        </Button>
    </Dropdown>)

}

export default MenuNav;